import type { Maybe } from '@adornis/base/utilTypes.js';
import { subscribeByID } from '@adornis/baseql/operations/mongo.js';
import { stateful } from '@adornis/functional-lit/stateful.js';
import { useQuery } from '@adornis/functional-lit/use-query.js';
import { getLastEditor } from '@adornis/versioned-entity/api/get-last-editor.js';
import { format } from 'date-fns';
import { html } from 'lit';
import { of } from 'rxjs';
import { Person } from '../../users/entities/person.js';

export const LastEditorInformation = stateful((props: { referenceIds: Maybe<string[]> }) => {
  const { value: lastEditorInfo, loading: lastEditorInfoLoading } = useQuery(
    () => (props.referenceIds ? getLastEditor(props.referenceIds)({ authorID: 1, timestamp: 1 }) : of(null)),
    [props.referenceIds?.join('')],
  );

  const { value: lastEditor, loading: lastEditorLoading } = useQuery(
    () =>
      subscribeByID(
        Person,
        lastEditorInfo?.authorID,
      )({ debitornenummer: 1, profilDaten: { stammdaten: { vorname: 1, nachname: 1 } } }),
    [lastEditorInfo?.authorID],
  );

  return lastEditorLoading || lastEditorInfoLoading
    ? html`<div class="loading loading-dots"></div>`
    : html`
        <p>
          Zuletzt bearbeitet von
          ${lastEditor
            ? html` <b>
                ${lastEditor?.profilDaten?.stammdaten?.vorname ?? lastEditor.debitornenummer}
                ${lastEditor?.profilDaten?.stammdaten?.nachname}
              </b>`
            : html`<b>---</b>`}
          am
          <b> ${lastEditorInfo?.timestamp ? format(lastEditorInfo.timestamp, "dd.MM.yyyy 'um' HH:mm") : '---'} </b>
        </p>
      `;
});
